import { render, staticRenderFns } from "./MapItemList.vue?vue&type=template&id=44486a56&scoped=true"
import script from "./MapItemList.vue?vue&type=script&lang=js"
export * from "./MapItemList.vue?vue&type=script&lang=js"
import style0 from "./MapItemList.vue?vue&type=style&index=0&id=44486a56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44486a56",
  null
  
)

export default component.exports